<template>
  <div class="container" v-show="isShow && !close">
    <div class="mask">
      <div class="dingwei" :class='[isnew == 1?"bg":"bg1"]'>

        <div class="wrap-card">
          <i class="el-icon-circle-close icon" @click="closed"></i>
          <div class='card card1' v-if="isnew == 1 && activitys['a1']">
            <div class="wrap-hongbao padding-10">
              <img src="/static/images/hongbao1.png" alt="">
            </div>
            <div class="wrap-info">
              <div class="wrap-info-title">{{activitys['a1']['name']}}</div>
              <div class="wrap-info-des">
                <div class="">
                  {{activitys['a1']['description']}}
                </div>
              </div>
            </div>
            <div class="price">
              <div class="base-line">
                <i class="currency">₱</i>{{activitys['a1']['amount']}}
              </div>
            </div>
          </div>

          <div class='card card1' v-if="activitys['a2']">
            <div class="wrap-hongbao">
              <img src="/static/images/hongbao2.png" alt="">
            </div>
            <div class="wrap-info">
              <div class="wrap-info-title">{{activitys['a2']['name']}}</div>
              <div class="wrap-info-des ">
                有效期：{{activitys['a2']['expire']}}<br>
                {{activitys['a2']['description']}}
              </div>
            </div>
            <div class="price">
              <div class="base-line">
                <i class="currency">₱</i>{{activitys['a2']['amount']}}
              </div>
            </div>
          </div>

          <div class='card card1' v-if="activitys['a3']">
            <div class="wrap-hongbao"> <img src="/static/images/jifen.png" alt="">
            </div>
            <div class="wrap-info">
              <div class="wrap-info-title">{{activitys['a3']['amount']}}积分</div>
              <div class="wrap-info-des ">{{activitys['a3']['description']}}</div>
            </div>
            <div class="price">
              <div class="base-line">
                {{activitys['a3']['amount']}}
              </div>
            </div>
          </div>

          <div class="wrap-btn" @click="received">立即领取 <i class="el-icon-arrow-right"></i></div>

          <div class="wrap-logo">
            <img src="/static/images/logo-bottom.png" alt="">
          </div>
        </div>
      </div>
      <div v-loading="true" v-loading.fullscreen.lock="isShow" element-loading-text="" element-loading-spinner=""
        spinner="" element-loading-background="rgba(0, 0, 0, .5)">
      </div>
    </div>
  </div>
</template>

<script>
  import config from '@/config';
  export default {
    name: "adver",
    props: {
      isnew: Number,
      isShow: Boolean,
      activitys: [Object, Array],
    },
    data() {
      return {
        close: false,
      }
    },
    methods: {
      closed() {
        this.close = true;
      },
      received() {
        this.close = true;
        let auth_token = localStorage.getItem('auth_token');
        if (!auth_token) {
          switch(this.$client) {
           case 'wxh5':
              window.location.href = config.api_url+'Wx/grant';
              break;
           case 'magapp':
              window.location.href = config.login_url;
              break;
            case 'h5':
              window.location.href = config.login_url + '&source=0';
              break;
           default:
              this.$message({
                 message: "非法客户端！",
                 type: "warning"
              })
              break;
          }
        } else {
          this.$api
            .request('Member/receive')
            .then(({ data }) => {
              this.$message({
                message: "领取成功！",
                type: "success"
              })
              this.$emit("received", true);
            })
            .catch(error => {
              this.$message({
                message: error,
                type: "warning"
              })
            });
        }
      }
    }
  }
</script>

<style>
  .container {}

  .general {
    font-size: 10px;
    display: inline-block;
    transform: scale(0.8);
    -webkit-transform: scale(0.8);
    transform-origin: 0 0
  }

  .currency {
    font-size: 12px;
  }

  .bg {
    background: url(/static/images/bg.png) no-repeat;
  }

  .bg1 {
    background: url(/static/images/bg1.png) no-repeat;
  }

  .dingwei {
    background-size: 100%;
    position: relative;
    margin: auto 0;
    z-index: 20000;
  }

  .wrap-logo {
    position: absolute;
    width: 100%;
    bottom: 10px;

  }

  .el-loading-mask.is-fullscreen .el-loading-spinner {
    display: none;
  }

  .mask {
    z-index: 9999;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .wrap-card {
    box-sizing: border-box;
    height: 100%;
    padding: 100px 15px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .wrap-card .card {
    box-sizing: border-box;
    width: 100%;
    background-size: 100% 100%;

    position: relative;
  }

  .card1 {
    background: url(/static/images/card1.png) no-repeat;
    height: 70px;
    margin-bottom: 10px;
  }

  .card2 {
    background: url(/static/images/card2.png) no-repeat;
    height: 90px;
    margin-bottom: 10px;
  }

  .card1 .wrap-hongbao {
    margin: 10px 6px;
  }

  .card2 .wrap-hongbao {
    margin: 20px 6px;
  }

  .padding-10 {
    padding: 10px
  }

  .card .wrap-hongbao {
    box-sizing: border-box;
    width: 50px;
    height: 50px;

    background-color: #ddd;
    float: left;

    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .wrap-hongbao img {
    width: 100%;
    height: auto;
    max-width: 40px;
  }

  .card2 .wrap-info {
    padding-top: 20px !important
  }

  .wrap-info {

    width: 50%;
    padding-top: 10px;
    text-align: left;
    float: left;
  }

  .wrap-info-title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    transfrom: scale(0.8)
  }

  .wrap-info-des {
    font-size: 12px;
    color: #999;
    text-overflow: ellipsis;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

  }

  .price {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
    padding: 10px;
    box-sizing: border-box;

    color: #e43;
  }

  .card1 .price {
    height: 70px;
    width: 70px;
  }

  .card2 .price {
    height: 90px;
    width: 80px;
  }

  .wrap-btn {
    margin-top: 0px;
    width: 50%;
    box-sizing: border-box;
    font-weight: bold;
    padding: 3px 20px;
    border-radius: 20px;
    line-height: 1.5;
    background: url(/static/images/btn.png) no-repeat center;
    color: #e43;
    z-index: 2;

  }

  .wrap-logo img {
    width: 50px;
    height: auto;
  }

  .el-icon-circle-close.icon {
    position: absolute;
    top: -15px;
    right: -15px;
    font-size: 30px;
    font-weight: bold;
    color: #fff;
  }

  @media screen and (max-width:767px) {
    .dingwei {
      width: 300px;
      height: 400px;

    }

    .wrap-info-des {

      transfrom: scale(0.8);
      display: block;
      /*  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden; */
    }
  }

  @media screen and (min-width: 768px) {
    .dingwei {
      width: 420px;
      height: 560px;
    }

    .wrap-card .card.card1 {
      height: 90px;
    }

    .wrap-card .card2 {
      height: 110px;
    }

    .card .wrap-info-title {
      margin-bottom: 5px;
      font-size: 18px;
    }

    .card .wrap-info-des {
      font-size: 16px;
    }

    .card .wrap-hongbao {
      width: 70px;
      height: 70px;
    }

    .card1 .price {
      width: 90px;
      height: 90px;
      font-size: 24px;
    }

    .card2 .price {
      width: 100px;
      height: 110px;
      font-size: 24px;
    }
    .wrap-logo{
      display: none;
    }
    .wrap-card{
      padding-top: 160px;
    }
    .wrap-logo img {
      width: 100px;
      height: auto;
    }

    .wrap-btn {
      margin-top: 20px;
      padding: 10px 20px;
    }


  }
</style>



// WEBPACK FOOTER //
// src/components/adver.vue